import { render, staticRenderFns } from "./CitationEdit.vue?vue&type=template&id=67111a86"
import script from "./CitationEdit.vue?vue&type=script&lang=js"
export * from "./CitationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports